import Axios from 'axios';

class ReenrollmentContractsService {
  getReenrollmentContracts(institutionId) {
    return Axios.get('/admin/reenrollment-contracts', { params: { institution_id: institutionId } });
  }

  disableReenrollmentContract(reenrollmentContractId, institutionId) {
    return Axios.put(
      `/admin/reenrollment-contracts/${reenrollmentContractId}/disable`,
      { institution_id: institutionId },
    );
  }

  createReenrollmentContract(institutionId, period) {
    return Axios.post('/admin/reenrollment-contracts', { institution_id: institutionId, period });
  }

  importStudentsReenrollmentCsv(reenrollmentContractId, institutionId, importFile) {
    const formData = new FormData();
    formData.append('import_file', importFile);
    formData.append('reenrollment_contract_id', reenrollmentContractId);
    formData.append('institution_id', institutionId);

    return Axios.post('/admin/rematricula/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new ReenrollmentContractsService();
